define('rebrush/components/plugin/usercentrics',[
    'jquery',
    'lodash',
    'cartware/components/_base'
], function(
    $,
    _,
    Component
) {
    const modalTriggerClass = 'uc-modal-trigger';

    function modifyAjaxResponse(response) {
        if (response.getHeader('content-type') && response.getHeader('content-type').match(/text\/html/gi)) {
            var container = $('<div />');
            container.html(response.responseText);

            var scripts = container.find('script[data-usercentrics][type="text/plain"]');

            scripts.each(function () {
                var script = $(this);
                script.attr('type', 'text/javascript');

                $('body').append(script);
            });
        }
    }

    return Component.create({
        $init: function () {
            var self = this;

            Ajax.Responders.register({
                onComplete: function(request, response) {
                    modifyAjaxResponse(response);
                }
            });

            $(document).ajaxComplete(function(event, xhr) {
                xhr.getHeader = xhr.getResponseHeader;
                modifyAjaxResponse(xhr);
            });

            $(document.body).on('click', '.' + modalTriggerClass, function(e) {
                e.preventDefault();
                self.triggerModal();
            });
        },

        triggerModal: function () {
            var userCentricsUi = _.get(window, 'UC_UI') || null;

            if (typeof userCentricsUi !== 'undefined') {
                userCentricsUi.showSecondLayer();
            }
        }
    });
});

